import { META_DATA } from 'src/services/constants';
import { equals, filter, flatten, gt, includes, map, pathOr, prop, toLower } from 'ramda';
import { mkObject } from 'src/services/objects/build';
import { buildAssigneeGroupForReAssign } from 'src/features/Advisors/AllTasks/assigneeGroups';
import { LENDSMART_WITHOUT_BOT } from 'src/services/constants/activites';
import { buildLabel, getFullName } from './naming';
import { filterIsNotEmpty, isNotEmpty } from './hasValue';
import { PodConfig } from 'src/components/Widgets/Users/PodConfig/types';


interface advisorDetails {
  firstName: string;
  lastName: string;
  accountId: string;


}

export const randomNumberRange = (n: number) => {

  return Math.floor(Math.random() * n);
};

const randomNumber = (n: number) => {
  if (n > 15) {
    n = 15;
  }
  return randomNumberRange(Math.pow(10, n));
};



export const mkAdvisorProfile = (advisorDetails: advisorDetails) => {
  const { firstName, lastName, accountId } = advisorDetails
  const userName = isNotEmpty(lastName) ? `${firstName}-${lastName}` : `${firstName}-${randomNumber(1)}`
  const object_meta = mkObject(userName);
  const data = {
    object_meta,
    source_id: `${randomNumber(15)}`,
    user_name: toLower(userName),
    status: { phase: 'Pending' },
    account_id: accountId,
  };

  return data;
};

export const getAdvisorProfile = (data: any, searchKey: string = 'email') => {
  const advisorProfile = pathOr([], ['data', 'advisor_profiles'], data);
  return buildAssigneeGroupForReAssign(advisorProfile, searchKey);
};

export const getAdvisorProfileDetails = (advisor: any) => {
  const advisorName = getFullName(advisor) || LENDSMART_WITHOUT_BOT;
  const oneUpEmail = pathOr('', [META_DATA, buildLabel('supervisor_email')], advisor);
  return { advisorName, oneUpEmail }
}

export const filterAdvisorsByRole = (advisors: any[], role: string) => {
  const advisorProfiles = filter(
    (advisor: any) => includes(role, pathOr([], ['account', 'roles_id'], advisor)),
    advisors
  );
  return advisorProfiles
}

export const filterAdvisorsByEmails = (advisors: any[], emails: string[]) => {
  const advisorProfiles = filter(
    (advisor: any) => includes(pathOr('', ['email'], advisor), emails),
    advisors
  );
  return advisorProfiles
}

export const getLoanOfficers = (data: any, role: string) => {
  return advisorListOptions(
    filterAdvisorsByRole(
      pathOr([], ['advisor_profiles'], data),
      role
    )
  );
}

export const advisorListOptions = (advisorProfiles: any[]) => {
  return map((advisorProfile: any) => {
    return {
      label: getFullName(advisorProfile),
      value: pathOr('', ['email'], advisorProfile)
    }
  }, advisorProfiles);
}

export const getAdvisorsBasedOnLimit = (podConfigs: PodConfig[], loanAmount: string) => {
  const filteredConfigs:any= filter((config: PodConfig) => {
    const rules = pathOr([], ["rule", "rules"], config)
    return isNotEmpty(filter((rule:any) => {
      return equals(pathOr("", ["varmap_name"], rule), "mortgage_loan_amount") && gt(Number(pathOr("", ["api_resource_path_value", 0, "max"], rule)), Number(loanAmount))
    }, rules))
  }, podConfigs) || [];

  return filterIsNotEmpty(
    flatten(map((config: any) => {
      return map(prop('email'), pathOr([], ["assignees"],config));
    }, filteredConfigs))
  ) as any
}